/**
 * JS function to open an image or div of images in fullscreen mode
 */

// all browsers should support requestFullscreen now, but just to
// ensure compatability with older browsers
const requestFullscreen =
  document.documentElement.requestFullscreen ||
  document.documentElement['webkitRequestFullscreen'] ||
  document.documentElement['msRequestFullscreen'] ||
  document.documentElement['mozRequestFullScreen'];

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function viewImageFullscreen(imgElement) {

  // If the document is not in full screen mode, make the image full screen
  if (!document.fullscreenElement) {

    // Replace any thumbnail images with the corresponding fullsize images
    if (imgElement.nodeName === 'DIV') {
      imgElement.childNodes.forEach(img => {
        if (img.nodeName === 'IMG') {
          const src = img.getAttribute('src')?.replaceAll(/attachment-(sm|med|lg)/g, 'attachment');
          if (src) {
            img.setAttribute('src', src);
          }
        }
      });
    } else if (imgElement.nodeName === 'IMG') {
      const src = imgElement.getAttribute('src')?.replaceAll(/attachment-(sm|med|lg)/g, 'attachment');
      if (src) {
        imgElement.setAttribute('src', src);
      }
    }

    if (requestFullscreen) {
      requestFullscreen.bind(imgElement)().catch(() => { });
    }

  } else {

    // Otherwise exit the full screen
    if (document.exitFullscreen) {
      document.exitFullscreen();
    }

  }

}
